import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const en = require("./locales/en.json");
const fr = require("./locales/fr.json");
const he = require("./locales/he.json");

i18n
  .use(LanguageDetector) // 👈 Add this
  .use(initReactI18next)
  .init({
    resources: { en, fr, he },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
    }
  });

// RTL auto-apply based on detected language
if (i18n.language === "he") {
  document.dir = "rtl";
} else {
  document.dir = "ltr";
}

export default i18n;
